import { StarPlusIcon } from './StarPlusIcon';

/**
 * author: Michael Irigoyen
 * id A782B3BE-28DC-4BF8-A209-42DC8F1CE287
 * name star-plus
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-plus.svg
 * tags
 * - Shape 
 */
export const FavoritePlusIcon = StarPlusIcon;
export default FavoritePlusIcon